import { Form, Input } from '@bancobarigui/barihaus';
import { FormInstance } from 'antd';
import { SignatureData } from '@/features/laudo/types/laudo-wizard.types';
import { ReviewFieldWrapper } from '../../ReviewFieldWrapper';

interface EvaluatorFormProps {
  form: FormInstance;
  data: SignatureData;
  onValuesChange: (_: any, allValues: any) => void;
  children: React.ReactNode;
  disabled?: boolean;
  allowEditAllInCorrection?: boolean;
}

export function EvaluatorForm({ form, data, onValuesChange, children, disabled, allowEditAllInCorrection }: EvaluatorFormProps) {
  return (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={onValuesChange}
      initialValues={{
        evaluatorName: data.evaluatorName,
        creaCauNumber: data.creaCauNumber,
      }}
    >
      <ReviewFieldWrapper
        fieldPath="signature.evaluatorName"
        fieldLabel="Nome do Avaliador"
        stepName="Assinatura"
        allowEditAllInCorrection={allowEditAllInCorrection}
      >
        <Form.Item
          label="Nome do Avaliador"
          name="evaluatorName"
          rules={[{ required: true, message: 'Campo obrigatório' }]}
        >
          <Input placeholder="Digite o nome completo do avaliador" disabled={disabled} />
        </Form.Item>
      </ReviewFieldWrapper>

      <ReviewFieldWrapper
        fieldPath="signature.creaCauNumber"
        fieldLabel="CREA/CAU Number"
        stepName="Assinatura"
        allowEditAllInCorrection={allowEditAllInCorrection}
      >
        <Form.Item label="CREA/CAU Number" name="creaCauNumber">
          <Input placeholder="Digite o número do CREA ou CAU (opcional)" disabled={disabled} />
        </Form.Item>
      </ReviewFieldWrapper>

      {children}
    </Form>
  );
}
